const hasFranchises = ["newCarsSales"];
const excludeGroups = ["variableOperationsCost", "fixedOperationsCost"];

export { hasFranchises, excludeGroups };
